import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var Approve = createPlugin({
    protocol: 'ERC721',
    type: 'ACTION',
    method: 'approve',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true, }),
                methodParams: {
                    to: new FctAddress({}),
                    tokenId: new FctValue({}),
                },
            },
            output: {},
        });
    },
});
